import { cache } from "react";
import { createMagentoClient } from "~/graphql";
import { CategoryFragment } from "~/graphql/shared/category";
import type { StoreInformationGenqlSelection } from "../genql/magento";

const country = {
	availableRegions: {
		code: true,
		id: true,
		name: true,
	},
	regionRequired: true,
	fullNameLocale: true,
	id: true,
	threeLetterAbbreviation: true,
	twoLetterAbbreviation: true,
};

const storeInformation = {
	code: true,
	name: true,
	companyName: true,
	locale: true,
	language: true,
	languageTwoLetterAbbreviation: true,
	countries: {
		...country,
	},
	country: {
		...country,
		regionRequired: true,
		availableRegions: {
			__scalar: true,
		},
	},
	baseUrl: true,
	timezone: true,
	currency: true,
	customerService: {
		isOpen: true,
		image: true,
		closeMessage: true,
		openTime: true,
		closeTime: true,
	},
	kiyoh: {
		totalScore: true,
		reviewCount: true,
		url: true,
		reviewUrl: true,
	},
	companyVideo: true,
	facebook: {
		facebookLikes: true,
		pageId: true,
		chatEnabled: true,
	},
	paymentMethods: {
		code: true,
		title: true,
		logo: true,
		paymentCharge: true,
		paymentChargeType: true,
		description: true,
		options: {
			optionId: true,
			name: true,
			logo: true,
		},
	},
	addressValidationAvailable: true,
	isCheckModeEnabled: true,
} satisfies StoreInformationGenqlSelection;

export type WebsiteData = Awaited<ReturnType<typeof getWebsite>>;

export const getWebsite = cache(async (locale: string) => {
	return await createMagentoClient(locale)
		.query({
			__name: "getWebsite",
			website: {
				available: {
					...storeInformation,
				},
				current: {
					...storeInformation,
					addressValidationAvailable: true,
					rootCategory: {
						id: true,
						children: {
							...CategoryFragment,
							children: {
								...CategoryFragment,
							},
						},
					},
				},
			},
		})
		.then((result) => result.website);
});
